module.exports = __webpack_public_path__ + "static/media/onboarding-modal-instruction.880514bc.svg";